import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import { Injectable } from "@angular/core";
import { Router } from '@angular/router';

declare var $ : any;
@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(
    private http: HttpClient,
    private route: Router
  ) { }

  descargaModal(file: string, name: string, ext: string) {
    return Swal.fire({
      title: '¿Estás seguro de que deseas descargar el archivo?',
      icon: 'info',
      confirmButtonText: 'Descargar',
      showCancelButton: true,
    }).then((result) => {
     // /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const nameDownload = name.trim() + ext;
        $('#downloadFile').attr('href', file);
        $('#downloadFile').attr('target', file);
        $('#downloadFile').attr('download', nameDownload);
        $('#downloadFile')[0].click();
      }
    });
  }

  descargarGuiaModal(base64File: string, fileName: string, fileExtension: string) {
    return Swal.fire({
      title: '¿Estás seguro de que deseas descargar esta guía?',
      icon: 'info',
      confirmButtonText: 'Descargar',
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        if (
          fileExtension === 'application/pdf'
        ) {
          const blob = new Blob([this.base64ToBytes(base64File)], {
            type: fileExtension,
          });
          let urlFile = window.URL.createObjectURL(blob);
          this.route.navigate([]).then(() => window.open(urlFile));
        } else {
          var a = document.getElementById('downloadFile');
          a.setAttribute(
            'href',
            `data:${fileExtension};base64,${base64File}`
          );
          a.setAttribute('download', unescape(fileName));
          a.click();
        }
      } 
    });
  }

  base64ToBytes(base64: string) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  enlaceModal(file: string) {
    return Swal.fire({
      title: '¿Estás seguro de que deseas continuar con el enlace?',
      icon: 'info',
      confirmButtonText: 'Continuar',
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        $('#downloadFile').attr('href', file);
        $('#downloadFile').attr('target', file);
        $('#downloadFile')[0].click();
      }
    })
  }
}
